import Loading from "@/components/Loading";
import { Suspense, lazy } from "react";
const Login = lazy(() => import("@pages/login/Login"));
const AutoLogin = lazy(() => import("@pages/auto-login/AutoLogin"));
const NotFound = lazy(() => import("@pages/404/NotFound"));
const Test = lazy(() => import("@pages/test/index"));

const publicRoute = [
  {
    path: "/login",
    name: "登录页",
    element: (
      <Suspense fallback={<Loading />}>
        <Login />
      </Suspense>
    ),
  },
  {
    path: "/autoLogin",
    name: "过渡页",
    element: (
      <Suspense fallback={<Loading />}>
        <AutoLogin />
      </Suspense>
    ),
  },

  {
    path: "/test",
    name: "test",
    element: <Test />,
  },
  {
    path: "/404",
    name: "404",
    element: <NotFound />,
  },
];
export default publicRoute;
